// The question on its own line (13 Oct, from the call with MedSnapp): a stem that ends in a question after a case is set
// as two lines, the case and then the question. One rule for the phone, the stage, the host and ops views and the
// answers page. A stem that is one sentence, or does not end in a question, stays one line.

/** Abbreviations whose full stop does not end a sentence. */
const ABBREVIATION = /\b(?:e\.g|i\.e|vs|approx|etc|cf|Dr|Mr|Mrs|Ms|Prof|St|No)\.$/i;
/** A sentence ends at . ? or ! followed by a space and a capital, a digit or an opening quote or bracket. */
const BOUNDARY = /[.?!]\s+(?=[A-Z0-9"'‘“(])/g;

export interface SplitStem { lead?: string; ask: string }

/** The case before the final question and the question itself; `lead` is absent when there is nothing to split. */
export function splitStem(text: string): SplitStem {
  const t = text.trim();
  if (!t.endsWith('?')) return { ask: t };
  let cut = -1; let next = -1;
  for (const m of t.slice(0, -1).matchAll(BOUNDARY)) {
    const end = (m.index ?? 0) + 1;
    if (ABBREVIATION.test(t.slice(0, end))) continue;
    cut = end; next = (m.index ?? 0) + m[0].length;
  }
  if (cut < 0) return { ask: t };
  return { lead: t.slice(0, cut).trim(), ask: t.slice(next).trim() };
}

/** For the stage's size steps, which go by length: a split stem sets one line more, counted as this many characters. */
export const BREAK_ALLOWANCE = 30;
/** The stem's length for sizing, with the extra line counted. */
export function sizedLength(text: string): number {
  return text.length + (splitStem(text).lead ? BREAK_ALLOWANCE : 0);
}
